import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "reactstrap";
import Drawer from "..";
import { ProfileProvider } from "../../../features/Profile/context";
import Documents from "../../../features/Profile/Documents";
import ExpectedHours from "../../../features/Profile/ExpectedHours";
import JobPay from "../../../features/Profile/JobPay";
import Notes from "../../../features/Profile/Notes";
import Overview from "../../../features/Profile/Overview";
import PBJ from "../../../features/Profile/PBJ";
import Personal from "../../../features/Profile/Personal";
import Settings from "../../../features/Profile/Settings";
import TimeOff from "../../../features/Profile/TimeOff";
import WorkingShifts from "../../../features/Profile/WorkingShifts";
import History from "./History";
import "./style.scss";
import Topbar from "./Topbar";

function ProfileDrawer({ user, visible, close }) {
	const { t } = useTranslation();
	const [menu, setMenu] = useState("job-pay");

	const content = useMemo(() => {
		switch (menu) {
			case "personal": {
				return <Personal isOpenFromTimesheet={true} />;
			}
			case "job-pay": {
				return <JobPay isOpenFromTimesheet={true} />;
			}
			case "time-off": {
				return <TimeOff isOpenFromTimesheet={true} />;
			}
			case "pbj": {
				return <PBJ isOpenFromTimesheet={true} />;
			}
			case "documents": {
				return <Documents isOpenFromTimesheet={true} />;
			}
			case "notes": {
				return <Notes isOpenFromTimesheet={true} />;
			}
			case "settings": {
				return <Settings isOpenFromTimesheet={true} />;
			}
			case "history": {
				return <History />
			}
			case "expected-hours": {
				return <ExpectedHours isOpenFromTimesheet={true} />;
			}
			case "working-shifts": {
				return <WorkingShifts isOpenFromTimesheet={true} />;
			}
			default:
				return <></>;
		}
	}, [menu]);

	return (
		<ProfileProvider id={user?.id} isSelf={false}>
			<Drawer
				open={visible}
				close={close}
				title={
					<>
						<h3 className="mb-0">{t("profile")}</h3>
						<h5 className="text-muted">
							{t("improve-business-efficiency")}
						</h5>
					</>
				}
			>
				<Topbar menu={menu} setMenu={setMenu} />

				<Overview />
				<Card className="profile-card">{content}</Card>
			</Drawer>
		</ProfileProvider>
	);
}

export default ProfileDrawer;
